import { useState, useCallback } from 'react';

export default function useErrorDrawer() {
  const [isOpen, setIsOpen] = useState(false);
  const [errorTitle, setErrorTitle] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const showError = useCallback(({ title, message }) => {
    setErrorTitle(title);
    setErrorMessage(message);
    setIsOpen(true);
  }, []);

  const hideError = useCallback(() => {
    setIsOpen(false);
    setErrorTitle(null);
    setErrorMessage(null);
  }, []);

  return {
    isOpen,
    errorTitle,
    errorMessage,
    showError,
    hideError,
  };
}
